export default {"src":"/_next/static/media/Apache Spark.010db4df.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};